import request from '@/plugin/axios'



export function enterpriseDetail(param){
    return request({
        url:"/api/admin/sysEnterprise/enterpriseDetail",
        method:'get',
        params:param
    })
}

export function toExamine(data){
    return request({
        url:"/api/admin/sysEnterpriseOpen/toExamine",
        method:"post",
        data:data
    })
}